// extracted by mini-css-extract-plugin
module.exports = {"mensajeContenedor":"ErrorGenerico_mensajeContenedor__3NE3P"};